import Service from '../Service'
class FlagsService extends Service {
  constructor() {
    super('FLAGS')
    this.resource = 'flags'
  }

  hasParameter(string) {
    if (string.substr(string.length - 1) === '?') return false
    return true
  }

  createRequestUrl(query = null) {
    let requestUrl = `${this.resource}?`

    if(query)
      query = this.encodeQueryValues(query);

    if (query && query.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${query.todos}`
        : `TODOS=${query.todos}`

    if (query && query.page)
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`

    if (query && query.filial)
      requestUrl += this.hasParameter(requestUrl)
        ? `&FILIAL=${query.filial}`
        : `FILIAL=${query.filial}`

    return requestUrl
  }

  async getFlagsAPI(query = null) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async getFlagAPI(descricao) {
    let requestUrl = `${this.resource}/${encodeURIComponent(descricao)}/`
    return await this.getAPI(requestUrl)
  }
}

export default new FlagsService()
